/**
 * Витрина свёрнута 16.10.2026 (вариант B по итогам бета-теста 08.08): портал и
 * /channels/* отдают 410, B выключил вызовы, расписания и уведомления.
 *
 * Флаг прячет раздел /showcase/*, пункт меню, ветку онбординга (карточка на
 * развилке, экраны согласия и правил, донастройка после оплаты) и фильтр
 * «Только Витрина» у суперадминов. Код не удаляем до окончательного решения
 * (~16.11.2026): вернуть раздел = поставить true и выкатить.
 *
 * useShowcaseAccess() не трогаем — он же определяет суперадмина в выборе канала.
 */
export const SHOWCASE_ENABLED = false
